export default __webpack_public_path__ + "static/media/ic-crops-green-vege.d18252ea.svg";